import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import { Tabs, Tab } from "material-ui/Tabs";
import Paper from "material-ui-next/Paper";
import Typography from "material-ui-next/Typography";

import { Page, Loadable, Errorable, IconButton } from "components/support";

import { colors } from "assets";

import CustomerGeneralInfo from "./general-info";
import CustomerGeographicInfo from "./geographic-info";
import CustomerCustomInfo from "./custom-info/index";

export default class CustomerView extends Component {
  render() {
    const { presenter, viewModel } = this.props;
    const { loading, error, customer, fields, configCustomFields } = viewModel;

    return (
      <Page>
        <Row>
          <Col xs={12}>
            <Typography type="display1" className="pb-sm">
              <Row>
                <Col xs>
                  <IconButton
                    icon="arrow_back"
                    onClick={() => presenter.onGoBack()}
                  />

                  {customer ? customer.name : "Visualizar Cliente"}
                </Col>
                <Col>
                  <IconButton
                    icon="mode_edit"
                    onClick={() => presenter.onEdit(customer)}
                  />
                  <IconButton
                    icon="delete"
                    onClick={() => presenter.onRequestDelete(customer)}
                  />
                </Col>
              </Row>
            </Typography>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <Errorable error={!!error} errorMessage={error}>
              <Loadable loading={loading}>
                <Paper elevation={1}>
                  <Tabs
                    inkBarStyle={{ backgroundColor: colors.accent.normal }}
                    tabItemContainerStyle={{
                      backgroundColor: colors.primary.dark
                    }}
                    className="customer-form-tabs"
                  >
                    <Tab label="Geral" className="tab-content">
                      {customer && (
                        <CustomerGeneralInfo
                          customer={customer}
                          fields={fields}
                        />
                      )}
                    </Tab>
                    <Tab label="Endereço" className="tab-content">
                      {customer && (
                        <CustomerGeographicInfo
                          customer={customer}
                          fields={fields}
                        />
                      )}
                    </Tab>
                    <Tab
                      label="Informações Personalizadas"
                      className="tab-content"
                    >
                      {customer && (
                        <CustomerCustomInfo
                          customer={customer}
                          configCustomFields={configCustomFields}
                        />
                      )}
                    </Tab>
                  </Tabs>
                </Paper>
              </Loadable>
            </Errorable>
          </Col>
        </Row>
      </Page>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/registration/customer/view/view.jsx